// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"621":"d2a0a5e0","681":"e4d74f20","738":"5dd583e3"}[chunkId] + ".chunk.css";
};